export default __webpack_public_path__ + "static/media/the-cook-house.a327614b.jpg";